import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Gate for the /vendor area: only a vendor session belongs here. Staff who
// wander in are sent to their dashboard, everyone else to the vendor login.
const VendorProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-700"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/vendor-login" />;
  if (user.actorType !== 'vendor') return <Navigate to="/dashboard" />;

  return children;
};

export default VendorProtectedRoute;
